import * as React from "react";
import { JSX } from "react/jsx-runtime";

const Bee = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={121}
    height={123}
    viewBox="0 0 121 123"
    fill="none"
    {...props}
  >
    <circle cx={60.5} cy={60} r={60} fill="#FFF1D7" />
    <g clipPath="url(#clip0_4226_136542)">
      <path
        d="M103.13 79.137C100.176 61.432 85.3003 44.7119 67.724 39.9653C54.3912 36.3697 40.1059 39.5618 29.606 49.3636C15.5859 62.4288 10.0888 82.8275 20.3356 98.6101C28.967 111.913 45.2293 120.658 61.371 121.619C70.786 122.189 80.8641 119.792 88.6516 113.954C101.418 104.377 105.191 91.5138 103.13 79.1251V79.137Z"
        fill="#FFD56A"
      />
      <mask
        id="mask0_4226_136542"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={38}
        width={92}
        height={84}
      >
        <path
          d="M103.114 79.1372C100.068 61.4322 84.7261 44.7122 66.5994 39.9655C52.8489 36.3699 38.1163 39.562 27.2875 49.3639C12.8283 62.429 7.15908 82.8277 17.7268 98.6103C26.6285 111.913 43.4001 120.658 60.0474 121.62C69.7572 122.189 80.1509 119.792 88.1824 113.954C101.348 104.377 105.24 91.5141 103.114 79.1253V79.1372Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4226_136542)">
        <path
          d="M106.21 82.2582C105.053 86.3878 103.251 90.3512 100.988 94.113C98.7128 97.8628 95.9403 101.387 92.683 104.508C86.1932 110.774 77.7887 115.378 68.7626 117.573C64.2496 118.677 59.7366 119.282 55.0992 119.448C50.4867 119.591 45.8121 119.163 41.299 118.048C36.786 116.956 32.4843 115.093 28.6924 112.613C24.9004 110.121 21.6431 107.024 19.0695 103.535L19.9895 102.74C23.309 105.434 26.8275 107.76 30.607 109.492C32.4967 110.346 34.4238 111.094 36.4006 111.676C38.3774 112.257 40.3914 112.66 42.418 113.005C46.4834 113.634 50.6235 113.657 54.7511 113.325C56.8149 113.159 58.8787 112.91 60.9177 112.53C62.9691 112.21 65.0204 111.735 66.9848 111.225C74.8919 109.112 82.2272 105.339 88.5802 100.248C91.763 97.7085 94.7344 94.8724 97.4571 91.7634C100.192 88.6662 102.666 85.2961 105.091 81.7954L106.222 82.2819L106.21 82.2582Z"
          fill="#213546"
        />
        <path
          d="M106.21 82.2582C105.053 86.3878 103.251 90.3512 100.988 94.113C98.7128 97.8628 95.9403 101.387 92.683 104.508C86.1932 110.774 77.7887 115.378 68.7626 117.573C64.2496 118.677 59.7366 119.282 55.0992 119.448C50.4867 119.591 45.8121 119.163 41.299 118.048C36.786 116.956 32.4843 115.093 28.6924 112.613C24.9004 110.121 21.6431 107.024 19.0695 103.535L19.9895 102.74C23.309 105.434 26.8275 107.76 30.607 109.492C32.4967 110.346 34.4238 111.094 36.4006 111.676C38.3774 112.257 40.3914 112.66 42.418 113.005C46.4834 113.634 50.6235 113.657 54.7511 113.325C56.8149 113.159 58.8787 112.91 60.9177 112.53C62.9691 112.21 65.0204 111.735 66.9848 111.225C74.8919 109.112 82.2272 105.339 88.5802 100.248C91.763 97.7085 94.7344 94.8724 97.4571 91.7634C100.192 88.6662 102.666 85.2961 105.091 81.7954L106.222 82.2819L106.21 82.2582Z"
          fill="black"
          fillOpacity={0.2}
        />
        <path
          d="M106.818 90.4815C105.787 94.6111 104.108 98.5983 101.957 102.396C99.7941 106.181 97.1086 109.753 93.9259 112.921C87.5728 119.27 79.1559 123.922 70.0926 125.963C65.5795 126.995 61.054 127.517 56.4291 127.553C51.8166 127.577 47.1668 126.948 42.7408 125.666C38.3024 124.396 34.1126 122.367 30.4574 119.768C26.8022 117.158 23.6692 113.989 21.1827 110.489L22.1276 109.717C25.3849 112.459 28.8039 114.867 32.4964 116.73C33.3915 117.229 34.3612 117.62 35.2937 118.024C36.2137 118.463 37.1959 118.795 38.1656 119.116C39.1229 119.484 40.1175 119.733 41.0997 119.982C42.0695 120.279 43.0765 120.457 44.0711 120.67C52.0653 122.189 60.4697 121.501 68.4142 119.578C76.2591 117.62 83.5198 113.859 89.7361 108.721C92.8442 106.157 95.7286 103.274 98.3519 100.129C101 96.9844 103.35 93.5787 105.675 90.0425L106.818 90.4934V90.4815Z"
          fill="#213546"
        />
        <path
          d="M106.818 90.4815C105.787 94.6111 104.108 98.5983 101.957 102.396C99.7941 106.181 97.1086 109.753 93.9259 112.921C87.5728 119.27 79.1559 123.922 70.0926 125.963C65.5795 126.995 61.054 127.517 56.4291 127.553C51.8166 127.577 47.1668 126.948 42.7408 125.666C38.3024 124.396 34.1126 122.367 30.4574 119.768C26.8022 117.158 23.6692 113.989 21.1827 110.489L22.1276 109.717C25.3849 112.459 28.8039 114.867 32.4964 116.73C33.3915 117.229 34.3612 117.62 35.2937 118.024C36.2137 118.463 37.1959 118.795 38.1656 119.116C39.1229 119.484 40.1175 119.733 41.0997 119.982C42.0695 120.279 43.0765 120.457 44.0711 120.67C52.0653 122.189 60.4697 121.501 68.4142 119.578C76.2591 117.62 83.5198 113.859 89.7361 108.721C92.8442 106.157 95.7286 103.274 98.3519 100.129C101 96.9844 103.35 93.5787 105.675 90.0425L106.818 90.4934V90.4815Z"
          fill="black"
          fillOpacity={0.2}
        />
      </g>
      <path
        d="M64.2518 46.8831C64.2518 46.8831 66.2168 35.242 73.4498 32.8687"
        stroke="url(#paint0_linear_4226_136542)"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7278 35.7871C32.7278 35.7871 40.3949 41.8272 41.7089 47.6419"
        stroke="url(#paint1_linear_4226_136542)"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.1388 34.2925C77.6235 34.2925 78.8271 33.1077 78.8271 31.6463C78.8271 30.1848 77.6235 29 76.1388 29C74.6541 29 73.4505 30.1848 73.4505 31.6463C73.4505 33.1077 74.6541 34.2925 76.1388 34.2925Z"
        fill="url(#paint2_linear_4226_136542)"
      />
      <path
        d="M31.0759 36.9861C32.5605 36.9861 33.7641 35.8013 33.7641 34.3399C33.7641 32.8784 32.5605 31.6936 31.0759 31.6936C29.5912 31.6936 28.3876 32.8784 28.3876 34.3399C28.3876 35.8013 29.5912 36.9861 31.0759 36.9861Z"
        fill="url(#paint3_linear_4226_136542)"
      />
      <path
        opacity={0.36}
        d="M77.5548 105.343C84.4584 105.343 90.0548 99.7504 90.0548 92.8509C90.0548 85.9515 84.4584 80.3584 77.5548 80.3584C70.6512 80.3584 65.0548 85.9515 65.0548 92.8509C65.0548 99.7504 70.6512 105.343 77.5548 105.343Z"
        fill="url(#paint4_radial_4226_136542)"
      />
      <path
        opacity={0.36}
        d="M33.1104 108.12C40.0139 108.12 45.6104 102.526 45.6104 95.6271C45.6104 88.7276 40.0139 83.1345 33.1104 83.1345C26.2068 83.1345 20.6104 88.7276 20.6104 95.6271C20.6104 102.526 26.2068 108.12 33.1104 108.12Z"
        fill="url(#paint5_radial_4226_136542)"
      />
      <path
        d="M45.2125 90.2926C46.9193 90.1874 48.1815 88.1908 48.0316 85.833C47.8818 83.4751 46.3766 81.6489 44.6698 81.754C42.9629 81.8591 41.7008 83.8558 41.8506 86.2136C42.0005 88.5715 43.5056 90.3977 45.2125 90.2926Z"
        fill="#213546"
      />
      <path
        d="M45.2125 90.2926C46.9193 90.1874 48.1815 88.1908 48.0316 85.833C47.8818 83.4751 46.3766 81.6489 44.6698 81.754C42.9629 81.8591 41.7008 83.8558 41.8506 86.2136C42.0005 88.5715 43.5056 90.3977 45.2125 90.2926Z"
        fill="black"
        fillOpacity={0.2}
      />
      <path
        d="M66.0431 89.0875C67.7499 88.9824 69.0121 86.9857 68.8622 84.6279C68.7124 82.27 67.2072 80.4438 65.5004 80.5489C63.7936 80.654 62.5314 82.6507 62.6813 85.0085C62.8311 87.3664 64.3363 89.1926 66.0431 89.0875Z"
        fill="#213546"
      />
      <path
        d="M66.0431 89.0875C67.7499 88.9824 69.0121 86.9857 68.8622 84.6279C68.7124 82.27 67.2072 80.4438 65.5004 80.5489C63.7936 80.654 62.5314 82.6507 62.6813 85.0085C62.8311 87.3664 64.3363 89.1926 66.0431 89.0875Z"
        fill="black"
        fillOpacity={0.2}
      />
      <path
        d="M34.4331 117.223C31.8742 117.59 28.9703 117.2 26.846 116.835C20.9069 115.848 14.808 109.766 19.3206 103.829C23.4395 98.4261 34.1496 98.6234 37.9578 103.756C39.9908 106.492 41.2603 111.038 39.5328 114.198C38.5172 116.063 36.5909 116.908 34.4331 117.223Z"
        fill="#FFDF8F"
      />
      <path
        d="M85.678 117.691C88.2633 117.59 91.0428 116.681 93.0829 115.947C98.7472 113.908 103.628 106.84 98.0737 101.827C93.0184 97.2634 82.5019 99.3874 79.7063 105.11C78.2147 108.166 77.816 112.843 80.1018 115.645C81.4488 117.288 83.4987 117.775 85.6897 117.688L85.678 117.691Z"
        fill="#FFDF8F"
      />
      <path
        d="M53.0205 88.7576C53.9536 86.9012 56.3628 87.1367 58.1658 87.7223C58.9158 87.9659 59.1888 88.8343 58.7613 89.4969C58.3214 90.1787 57.7164 91.0322 57.0343 91.7602C56.3669 92.4725 55.6234 93.0895 55.0448 93.5298C54.486 93.955 53.6913 93.8453 53.3314 93.2422C52.6624 92.121 52.1384 90.5125 53.0205 88.7576Z"
        fill="#FAA83F"
      />
      <path
        d="M15.7492 34.5522C15.7492 39.5344 12.3242 43.5746 8.11035 43.5746C12.3242 43.5746 15.7492 47.6148 15.7492 52.597C15.7492 47.6148 19.1743 43.5746 23.3881 43.5746C19.1743 43.5746 15.7492 39.5344 15.7492 34.5522Z"
        fill="#6DDA85"
      />
      <path
        d="M97.6937 52.5972C97.6937 58.7291 93.6459 63.7016 88.6659 63.7016C93.6459 63.7016 97.6937 68.6742 97.6937 74.8061C97.6937 68.6742 101.741 63.7016 106.721 63.7016C101.741 63.7016 97.6937 58.7291 97.6937 52.5972Z"
        fill="#6DDA85"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4226_136542"
        x1={63.6491}
        y1={39.8818}
        x2={74.0526}
        y2={39.8818}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6E72" />
        <stop offset={1} stopColor="#4E4C4A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4226_136542"
        x1={32.1251}
        y1={41.7085}
        x2={42.2996}
        y2={41.7085}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6E72" />
        <stop offset={1} stopColor="#4E4C4A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4226_136542"
        x1={73.4505}
        y1={31.6463}
        x2={78.815}
        y2={31.6463}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6E72" />
        <stop offset={1} stopColor="#4E4C4A" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4226_136542"
        x1={28.3876}
        y1={34.3399}
        x2={33.7641}
        y2={34.3399}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6E72" />
        <stop offset={1} stopColor="#4E4C4A" />
      </linearGradient>
      <radialGradient
        id="paint4_radial_4226_136542"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(77.5602 92.8441) rotate(-3.57787) scale(12.5 12.4926)"
      >
        <stop stopColor="#FAA83F" />
        <stop offset={0.94} stopColor="#FFC92E" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_4226_136542"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.0871 95.6191) rotate(86.4179) scale(12.4926 12.5)"
      >
        <stop stopColor="#FAA83F" />
        <stop offset={0.94} stopColor="#FFD364" />
      </radialGradient>
      <clipPath id="clip0_4226_136542">
        <rect
          width={100}
          height={93}
          fill="white"
          transform="translate(9.5 29)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default Bee;
